import wordsToNumbers from "words-to-numbers";

const DE_NUMBERS = {
  null: 0, eins: 1, ein: 1, eine: 1, zwei: 2, drei: 3, vier: 4, fünf: 5,
  sechs: 6, sieben: 7, acht: 8, neun: 9, zehn: 10,
  elf: 11, zwölf: 12, dreizehn: 13, vierzehn: 14, fünfzehn: 15,
  sechzehn: 16, siebzehn: 17, achtzehn: 18, neunzehn: 19,
  zwanzig: 20, dreißig: 30, vierzig: 40, fünfzig: 50,
  sechzig: 60, siebzig: 70, achtzig: 80, neunzig: 90,
  hundert: 100, zweihundert: 200, dreihundert: 300,
  vierhundert: 400, fünfhundert: 500, tausend: 1000,
  einundzwanzig: 21, zweiundzwanzig: 22, dreiundzwanzig: 23,
  vierundzwanzig: 24, fünfundzwanzig: 25, sechsundzwanzig: 26,
  siebenundzwanzig: 27, achtundzwanzig: 28, neunundzwanzig: 29,
  einunddreißig: 31, zweiundvierzig: 42, fünfundvierzig: 45,
};

export function parseSpeechNumber(text) {
  const trimmed = text.trim().toLowerCase();

  // 1. Direct digit string
  const direct = Number(trimmed);
  if (!isNaN(direct) && trimmed !== "") return String(direct);

  // 2. Single German word
  if (trimmed in DE_NUMBERS) return String(DE_NUMBERS[trimmed]);

  // 3. Multi-word German sum ("drei hundert fünfzig" → 350)
  const words = trimmed.split(/\s+/);
  if (words.every((w) => w in DE_NUMBERS)) {
    return String(words.reduce((acc, w) => acc + DE_NUMBERS[w], 0));
  }

  // 4. English fallback
  const fallback = wordsToNumbers(trimmed, { fuzzy: true });
  if (fallback !== null && !isNaN(Number(fallback))) return String(Number(fallback));

  return null; // couldn't parse
}